
import { create, el } from "@dhx/ts-common/dom";
import { IHandlers } from "@dhx/ts-common/types";
import { View } from "@dhx/ts-common/view";
import { IButton } from "../types";
import { IEventSystem, EventSystem } from "@dhx/ts-common/events";

export enum ButtonEvents {
	click = "click"
}

export class Button extends View {
	public config: IButton;
	public events: IEventSystem<ButtonEvents>;
	private _handlers: IHandlers;
	constructor(container: HTMLElement | string, config = {}) {
		super(container, config);
		this.events = new EventSystem();
		this._handlers = {
			onclick: e => this.events.fire(ButtonEvents.click, [e])
		};
		const render = () => this._draw();
		this.mount(container, create({ render }));
	}
	setValue(value: string): void {
		this.config.value = value;
		this.paint();
	}
	protected _draw() {
		const  { color,	size, view,	full, loading, circle, icon, value,	disabled, submit, id } = this.config;
		const colorsCss = {
			danger: " dhx_button--color_danger",
			secondary: " dhx_button--color_secondary",
			primary: " dhx_button--color_primary",
			success: " dhx_button--color_success",
		}[color] || " dhx_button--color_primary";
		const sizeCss = {
			small: " dhx_button--size_small",
			medium: " dhx_button--size_medium",
		}[size] || " dhx_button--size_medium";
		const viewCss = {
			flat: " dhx_button--view_flat",
			link: " dhx_button--view_link",
		}[view] || " dhx_button--view_flat";
		const fullCss = full ? " dhx_button--width_full" : "";
		const circleCss = circle ? " dhx_button--circle" : "";
		const loadingCss = loading ? " dhx_button--loading" : "";
		const iconViewCss = icon && !value ? " dhx_button--icon" : "";
		return el("button", {
			disabled,
			id,
			onclick: this._handlers.onclick,
			type: submit ? "submit" : "button",
			class: "dhx_button" +
				colorsCss +
				sizeCss +
				viewCss +
				fullCss +
				circleCss +
				loadingCss +
				iconViewCss
		}, [
			icon && el("span.dhx_button__icon", {
				class: icon
			}),
			value && el("span.dhx_button__text", value),
			loading && el("span.dhx_button__loading", [
				el("span.dhx_button__loading-icon.dxi.dxi-loading")
			])
		]);
	}
}
